import { render, staticRenderFns } from "./cxGiftsAction.vue?vue&type=template&id=077c66f7&scoped=true"
import script from "./cxGiftsAction.vue?vue&type=script&lang=js"
export * from "./cxGiftsAction.vue?vue&type=script&lang=js"
import style0 from "./cxGiftsAction.vue?vue&type=style&index=0&id=077c66f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c66f7",
  null
  
)

export default component.exports